// extracted by mini-css-extract-plugin
export var acitonButtons = "_lu-0";
export var additionalIcon = "_lu-f";
export var block = "_lu-1";
export var blockContent = "_lu-7";
export var blockDescription = "_lu-8";
export var blockIcon = "_lu-9";
export var blockTitle = "_lu-6";
export var border = "_lu-a";
export var center = "_lu-l";
export var edge = "_lu-b";
export var edgeLabel = "_lu-c";
export var edgePath = "_lu-d";
export var error = "_lu-e";
export var flowchart = "_lu-g";
export var flowchartContent = "_lu-h";
export var highlighted = "_lu-3";
export var hover = "_lu-4";
export var icon = "_lu-i";
export var left = "_lu-m";
export var navButton = "_lu-j";
export var navButtons = "_lu-k";
export var right = "_lu-n";
export var selected = "_lu-2";
export var small = "_lu-5";